export default __webpack_public_path__ + "static/media/storeIcon.a1edebda.svg";